/**
 * StaticSectionFooter - Footer section with accordion and disclosures
 */
import * as breakpoint from '@theme/module-breakpoint';
import Accordion from '@theme/core-accordion';
import Forms from '@theme/core-forms';

export default class StaticSectionFooter {
  constructor(section) {
    this.el = section.el;
    this.currencyDisclosureEl = this.el.querySelector('[data-disclosure-currency]');
    this.localeDisclosureEl = this.el.querySelector('[data-disclosure-locale]');
    this.disclosures = [];

    this.Accordion = new Accordion(this.el);
    this.forms = new Forms(this.el);

    // Initialize disclosures if elements exist
    if (this.currencyDisclosureEl || this.localeDisclosureEl) {
      this._initDisclosures();
    }

    // Handle Accordion interaction when window size changes
    this.layoutHandler = this.onBreakpointChange.bind(this);
    breakpoint.onChange(this.layoutHandler);

    this._bindEvents();
  }

  async _initDisclosures() {
    // Dynamic import for cross-border disclosure component
    try {
      const { default: Disclosure } = await import('shopify-cross-border');

      if (this.currencyDisclosureEl) {
        this.disclosures.push(new Disclosure(this.currencyDisclosureEl));
      }

      if (this.localeDisclosureEl) {
        this.disclosures.push(new Disclosure(this.localeDisclosureEl));
      }
    } catch (e) {
      console.warn('Failed to load disclosure component:', e);
    }
  }

  _bindEvents() {
    this._boundAccordionClick = (event) => {
      const trigger = event.target.closest('[data-accordion-trigger]');
      if (trigger) {
        event.preventDefault();
        this._toggleAccordion(trigger.parentElement);
      }
    };

    this.el.addEventListener('click', this._boundAccordionClick);
  }

  onSectionUnload() {
    this.el.removeEventListener('click', this._boundAccordionClick);
    this.forms.unload();
    this.disclosures.forEach(disclosure => disclosure.unload());

    delete this.Accordion;
  }

  onSectionBlockSelect(block) {
    const blockEl = block.el;

    if (blockEl.classList.contains('has-accordion')) {
      this._toggleAccordion(blockEl, true);
    }
  }

  onSectionBlockDeselect(block) {
    const blockEl = block.el;

    if (blockEl.classList.contains('has-accordion')) {
      this._toggleAccordion(blockEl, false);
    }
  }

  _toggleAccordion(blockEl) {
    if (breakpoint.min('L')) return;

    this.Accordion.toggle(blockEl);
  }

  onBreakpointChange(breakpoints) {
    if (breakpoint.min('L')) {
      this.Accordion.openAll();
    } else if (breakpoints.previous === 'L' && !breakpoint.min('L')) {
      this.Accordion.closeOpen();
    }
  }
}
